import styled from 'styled-components';

export const Style = styled.div`
  height: 525px;
  position: relative;
  display: flex;
  flex-direction: column;
  margin-top: var(--size-lg);

  .row-a {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    flex: 1;
  }
  
  .row-b {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    flex: 2;
  }

  .item {
    border: 3px solid white;
    background: #F9FAFB;
    heihgt: 50%;
  }

  .message {
    position: absolute;
    opacity: 0;
    transition: .4s opacity;
    width: 400px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #FFFFFF;
    border: 1px solid #F2F4F7;
    box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
    border-radius: 8px;
    padding: var(--size);

    h5 {
      color: #101828;
      font-weight: 500;
      font-size: 14px;
      margin-bottom: 4px;
    }
    
    p {
      color: #667085;
      font-weight: 500;
      font-size: 14px;
      margin-bottom: 0px;
    }
  }

  &:hover {
    .message {
      opacity: 1;
    }
  }
`;
